import { render, staticRenderFns } from "./BodyPainPanel.vue?vue&type=template&id=1a2e2312&scoped=true&"
import script from "./BodyPainPanel.vue?vue&type=script&lang=js&"
export * from "./BodyPainPanel.vue?vue&type=script&lang=js&"
import style0 from "./BodyPainPanel.vue?vue&type=style&index=0&id=1a2e2312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e2312",
  null
  
)

export default component.exports